import { post, get, del } from '../Requester';
import { userId as storedUserId } from './LoginService';

export function prepareRegistration(user = storedUserId()) {
  return post(`passkeys/register/${user}/start`, {}, { checkAuthorization: true })
    .then(res => res.data);
}

export function finishRegistration(user = storedUserId(), credential) {
  return post(`passkeys/register/${user}/finish`, credential, { checkAuthorization: true })
    .then(res => res.data);
}

export function startAuthentication(email) {
  return post(`passkeys/login/start`, {email}, { checkAuthorization: false })
    .then(res => res.data);
}

export function finishAuthentication(user, credential) {
  return post(`passkeys/login/${user}/finish`, credential, { checkAuthorization: false })
    .then(res => res.data);
}

export function listPasskeys(user = storedUserId()) {
  return get(`passkeys/${user}`, {}, { checkAuthorization: true })
    .then(res => res.data);
}

export function deletePasskey(passkeyId) {
  return del(`passkeys/${passkeyId}`).then(res => res.data);
}